import { travelTypeObject } from '../../enumeration';
import { PATH_DASHBOARD } from '../../routes/paths';
import api from '../../services/api';

const EVisitorManagement = {
  title: { name: ['سوابق', 'سوابق'] },
  routes: PATH_DASHBOARD.records,
  api: api.travelHistory,
  enum: {
    array: Object.values(travelTypeObject),
    object: travelTypeObject,
  },
};

export default EVisitorManagement;
